import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
/**
 * Service for managing WebSocket communication.
 */
export class WebsocketService {
  private static instance: WebsocketService;

  private socket: Socket | undefined;
  private listeners: (() => void)[] = [];
  private isConnected = false;

  constructor() {
    if (WebsocketService.instance) {
      return WebsocketService.instance;
    }

    WebsocketService.instance = this;
  }

  connect(id: number) {
    this.socket = io(`${environment.socketUrl}`, {
      auth: { userId: id },
    });
    this.socket.emit('connection');

    this.socket.on('connect', () => {
      this.isConnected = true;

      // Exécute les écouteurs enregistrés avant la connexion
      this.listeners.forEach((cb) => cb());
      this.listeners = [];
    });

    this.socket.on('refresh-token--user-account', (data) => {
      // console.log('Received refresh token event:', data);
      // Handle the refresh token event here
    });
    this.socket.on('disconnect', () => {
      // console.log('Socket disconnected');
      this.isConnected = false;
    });

    this.socket.on('welcome', (message) => {
      // console.log('Received welcome message:', message);
    });
  }

  disconnect() {
    this.socket?.disconnect();
  }

  getSocket() {
    return this.socket;
  }

  listen<T = any>(event: string, callback: (data: T) => void): void {
    if (this.isConnected && this.socket) {
      // console.log('Listening to event:', event);
      this.socket.on(event, callback);
    } else {
      // Ajoute l'écouteur en attente de connexion
      this.listeners.push(() => {
        // console.log('Deferred listening to event:', event);
        this.socket?.on(event, callback);
      });
    }
  }

  destroyListeners() {
    this.socket?.removeAllListeners();
    this.listeners = [];
  }
}
